const { isEmpty } = require('lodash');

const isAgencyGig = (gig) => !isEmpty(gig.agency) && gig.agency.status === 'active';

module.exports = {
    isAgencyGig,
};
